(ns yardwerkz.web.profile.saved-addresses
  "Saved addresses/properties management."
  (:require
   [uix.core :refer [defui $ use-state use-effect]]
   [io.factorhouse.rfx.core :as rfx]
   [yardwerkz.web.store :as store]
   [yardwerkz.web.router :as router]
   [yardwerkz.web.ui.layout :as layout]
   [yardwerkz.web.ui.components :as ui]
   [yardwerkz.web.ui.icons :as icons]))

;; =============================================================================
;; Address Card
;; =============================================================================

(defui address-card [{:keys [addr]}]
  (let [address (or (:property/address addr) (:address addr) "Address")
        city (or (:property/city addr) (:city addr))
        state (or (:property/state addr) (:state addr))
        zone-count (count (or (:property/zones addr) (:zones addr) []))]
    ($ ui/card {:class "p-4"}
       ($ :div {:class "flex items-start space-x-3"}
          ($ :div {:class "p-2 bg-green-100 rounded-lg flex-shrink-0"}
             ($ icons/MapPin {:size 20 :class "text-green-600"}))
          ($ :div {:class "flex-1 min-w-0"}
             ($ :p {:class "font-medium text-gray-900 truncate"} address)
             (when (or city state)
               ($ :p {:class "text-sm text-gray-500"}
                  (str (or city "") (when (and city state) ", ") (or state ""))))
             (when (pos? zone-count)
               ($ :p {:class "text-xs text-gray-400 mt-1"}
                  (str zone-count " zone" (when (> zone-count 1) "s") " mapped"))))))))

;; =============================================================================
;; Page
;; =============================================================================

(defui saved-addresses-page []
  (let [dispatch (rfx/use-dispatch)
        customer-id (rfx/use-sub [::store/customer-id])
        addresses (rfx/use-sub [::store/saved-addresses])
        loading (rfx/use-sub [::store/saved-addresses-loading])]

    (use-effect
     (fn []
       (when customer-id
         (dispatch [::store/fetch-saved-addresses {:customer-id customer-id}]))
       js/undefined)
     [customer-id dispatch])

    ($ layout/page-container
       ($ :button {:class "flex items-center text-sm text-gray-500 hover:text-gray-700 mb-4"
                   :on-click #(router/navigate! :profile)}
          ($ icons/ChevronLeft {:size 16})
          ($ :span "Back to Profile"))
       ($ :h1 {:class "text-2xl font-bold text-gray-900 mb-6"} "Saved Addresses")
       (if loading
         ($ ui/skeleton-list {:count 3})
         (if (seq addresses)
           ($ :div {:class "space-y-3"}
              (for [addr addresses]
                ($ address-card {:key (or (:property/id addr) (:id addr))
                                 :addr addr})))
           ($ ui/empty-state
              {:icon ($ icons/Home {:size 48})
               :title "No saved addresses"
               :description "Addresses from your bookings will appear here."}))))))
